import { useTranslation } from 'react-i18next';

import Typography from 'components/global/Typography';

const ExportFileName = ({ value, data }) => {
	const { t } = useTranslation();
	return <Typography>{t(value, data.translationObject && JSON.parse(data.translationObject))}</Typography>;
};

export default ExportFileName;
